export const HARDCODED_CP_LAT = 28.632688;
export const HARDCODED_CP_LNG = 77.219407;

export const LAST_SAVED_LOCATION = "user_last_lat_lng_key";
